<template>
    //twitter, instagram
      <div class="p-8 mx-8 my-32 border border-gray-200 shadow-xl rounded-md font-sans">
    
        <h1 class="text-2xl font-semibold mb-6 text-center">Contact Information</h1>
    
        
   
        <div class="mb-6">
    
          <h2 class="text-lg font-semibold mb-2">Country</h2>
    
          <p class="text-gray-600 mb-2">Kenya</p>
    
          <h2 class="text-lg font-semibold mb-2">County</h2>
    
          <p class="text-gray-600 mb-2">Nairobi</p>
    
        </div>
        
        <!-- Social Media Links -->
    
        <div class="mb-6">
    
          <h2 class="text-lg font-semibold mb-2">Social Media:</h2>
    
          <ul class="flex justify-center space-x-32">
    
            <li>
              <a href="www.linkedin.com/in/davidwanjohi" class="flex items-center hover:text-blue-700">
    
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
    
                  <path fill-rule="evenodd" d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" clip-rule="evenodd" />
    
                </svg>
    
                linkedIn
    
              </a>
    
            </li>
    
            <li>
              <a href="https://www.instagram.com/e.davi2023/" class="flex items-center hover:text-blue-700">
    
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
    
                  <path d="M3.75 2A1.75 1.75 0 0 0 2 3.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.25.25 0 0 1 .25-.25h1.5a.75.75 0 0 0 0-1.5h-1.5ZM10.75 2a.75.75 0 0 0 0 1.5h1.5a.25.25 0 0 1 .25.25v1.5a.75.75 0 0 0 1.5 0v-1.5A1.75 1.75 0 0 0 12.25 2h-1.5ZM3.5 10.75a.75.75 0 0 0-1.5 0v1.5c0 .966.784 1.75 1.75 1.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.25.25 0 0 1-.25-.25v-1.5ZM14 10.75a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-1.5a.75.75 0 0 0 0 1.5h1.5A1.75 1.75 0 0 0 14 12.25v-1.5ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
    
                </svg>
    
                Instagram
    
              </a>
    
            </li>
    
            <li>
              <a href="https://twitter.com/DavyWagura" class="flex items-center hover:text-blue-700">
    
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
    
                  <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
    
                </svg>
    
                Twitter
    
              </a>
    
            </li>
    
            <li>
              <a href="davidwagura83@gmail.com" class="flex items-center hover:text-blue-700">
    
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
    
                  <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
    
                  <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
    
                </svg>
    
                Email
    
              </a>
    
            </li>
            <li>
              <a href="https://github.com/davidwagura" class="flex items-center hover:text-blue-700">
    
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
    
                  <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
    
                  <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
    
                </svg>
    
                Github
    
              </a>
    
            </li>

          </ul>
    
        </div>
    
      </div>
    
    </template>
    
    <script>
    </script>